// Translations
import landing from '../views/landing/translations/de'

// Translation: Verification (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
